<template>
    <div class="user-module w-full">
        <div class="flex flex-col mt-8 w-full">
            <div class="flex w-1/2">
                <div class="flex flex-col px-6 w-1/2">
                    <div class="form-group">
                        <label for="name">Naziv vozila</label>
                        <input
                            tabindex="1"
                            id="name"
                            class="form-control"
                            :class="{ _error: validationErrors.name}"
                            type="text"
                            v-model="form.name"
                        >
                        <span class="error-message" v-if="validationErrors.name" v-text="validationErrors.name[0]"></span>
                    </div>

                    <div class="form-group flex items-center mt-3">
                        <div class="box-switch mt-4">
                            <input
                                tabindex="3"
                                type="checkbox"
                                id="status"
                                name="status"
                                v-model="form.status"
                            >
                            <span class="switch-path"></span>
                            <label for="status" v-text="form.status ? 'Aktivan' : 'Neaktivan'"></label>
                        </div>
                        <span class="error-message" v-if="validationErrors.status" v-text="validationErrors.status[0]"></span>
                    </div>


                    <div class="form-group flex items-center">
                        <div class="box-switch mt-3">
                            <input
                                tabindex="5"
                                type="checkbox"
                                id="reports"
                                name="reports"
                                v-model="form.reports"
                            >
                            <span class="switch-path"></span>
                            <label for="reports" v-text="form.reports ? 'U izvještaju' : 'Nije u izvještaju'"></label>
                        </div>
                        <span class="error-message" v-if="validationErrors.reports" v-text="validationErrors.reports[0]"></span>
                    </div>
                </div>
                <div class="flex flex-col px-6 w-1/2">
                    <div class="form-group">
                        <label for="available">Status raspoloživosti</label>
                        <v-select
                            :tabindex="2"
                            class="form-select"
                            :class="{ _error: validationErrors.available}"
                            id="available"
                            v-model="form.available"
                            :options="availableList"
                            :clearable="false"
                        ></v-select>
                        <span class="error-message" v-if="validationErrors.available" v-text="validationErrors.available[0]"></span>
                    </div>

                    <div class="form-group">
                        <label for="registration">Registracijska oznaka</label>
                        <input
                            tabindex="4"
                            id="registration"
                            class="form-control"
                            :class="{ _error: validationErrors.registration}"
                            type="text"
                            v-model="form.registration"
                        >
                        <span class="error-message" v-if="validationErrors.registration" v-text="validationErrors.registration[0]"></span>
                    </div>
                </div>
            </div>
            <div class="flex justify-end items-start w-1/2 mt-8">
                <div class="flex flex-col mr-6">
                    <button
                        class="btn primary"
                        @click="submitForm()"
                        :disabled="procesing"
                    >Spremi</button>
                </div>
            </div>
        </div>
        <div>
            <h2 class="w-full mr-4" v-if="redirectMessage" v-text="redirectMessage"></h2>
        </div>
        <response
            v-if="showResponse"
            :data="responseData"
        ></response>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import Response from './Response'

export default {
    components: {
        vSelect,
        Response,
    },

    props: {
        vehicleData: {
            type: Object,
            default: () => ({})
        },
        availableList: {
            type: Array,
            default: () => ([])
        },
    },

    data() {
        return {
            form: {
                name: '',
                registration: '',
                available: 'Raspoloživ',
                status: true,
                reports: true,
            },
            validationErrors: {},
            redirectMessage: '',
            showResponse: false,
            responseData: {},
            procesing: false,
        }
    },

    created() {
        this.showLoader();
        // Set the inputs to values to given user data
        if (this.vehicleData.id) {
            _.forEach(this.form, (item, key) => {
                switch (key) {
                    case 'status':
                        if (!this.vehicleData.deleted_at) {
                            this.form.status = true
                        } else {
                            this.form.status = false
                        }
                        break;
                    case 'available':
                        if (this.vehicleData.available) {
                            this.form.available = 'Raspoloživ'
                        } else {
                            this.form.available = 'Neraspoloživ'
                        }
                        break;
                    default:
                        this.form[key] = this.vehicleData[key]
                        break;
                }
            })
        }

        setTimeout(() => {
            this.hideLoader();
        }, 500);
    },

    methods: {
        // Submit the form to create a new user
        submitForm() {
            this.procesing = true

            this.showLoader();

            const lastPage = localStorage.getItem('vehicles_last_page');

            let formData = new FormData();
            let endpoint = '';

            // Append all form items
            _.forEach(this.form, (item, key) => {
                formData.append(key, item)
            })

            // Conditionaly add method to form submit
            if (this.vehicleData.id) {
                formData.append("_method", 'PATCH');
            }

            if (lastPage) {
                formData.append('page', lastPage);
            }

            // Sets the endpoint with data for store/update depending on create or update
            if (this.vehicleData.id) {
                let data = {
                    vehicle: this.vehicleData.id,
                }
                endpoint = route('vehicles.update', data)
            } else {
                endpoint = route('vehicles.store')
            }

            // Send the formData to vehicle controller store/update function depending on endpoint
            axios.post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.responseData = response.data.data
                        this.showResponse = true

                        setTimeout(() => {
                            this.hideLoader();

                            const lastPage = localStorage.getItem('vehicles_last_page');
                            localStorage.removeItem('vehicles_last_page');

                            let redirectUrl = route("vehicles.index");
                            if (lastPage) {
                                redirectUrl += `?page=${lastPage}`;
                            }

                            window.location.href = redirectUrl;
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.procesing = false
                    if (typeof(error.response) !== 'undefined')
                        this.validationErrors = error.response.data.errors

                    console.error(error);
                    this.hideLoader();
                });
        },
    }
}
</script>
